// extracted by mini-css-extract-plugin
export var box = "_54-0";
export var check = "_54-1";
export var checkboxButton = "_54-6";
export var checkboxGroup = "_54-5";
export var disabled = "_54-7";
export var ghost = "_54-9";
export var input = "_54-2";
export var label = "_54-4";
export var normal = "_54-8";
export var uncheck = "_54-3";